import { Component, input, output } from '@angular/core';

@Component({
    selector: 'tag-list',
    templateUrl: './tag-list.component.html',
    styleUrls: ['./tag-list.component.scss'],
    standalone: false
})
export class TagListComponent {

  readonly tags = input<string[] | null>([]);

  readonly remove = output<string>();

}
